// neutral tier: app-specific, theme-agnostic component. Extends the base
// component directly (5 dirs up to the webapp root, then into core/themes/base).
// This is what metronic's own empty component/component.js passthrough resolves
// to, so behaviour is identical now that this file lives in neutral.
const component = require('../../../../../core/themes/base/components/component/component');

const freshChat = Object.assign({}, component, {
    agentViewUrl: '',
    externalId: '',
    firstName: '',
    email: '',
    phone: '',
    marketplaceGroupSku: '',
    marketplaceGroup: '',
    partnerName: '',
    storeName: '',
    storeAlias: '',
    storeDomain: '',
    tags: [],

    init: function () {
        component.init.call(this);

        let csbLink = '';

        if (this.agentViewUrl) {
            csbLink = '<a href="' + this.agentViewUrl + '" target="_blank">' + this.externalId + '</a>';
        }

        if (typeof window.fcWidget !== typeof undefined) {
            window.fcWidget.setTags(this.tags);

            window.fcWidget.user.setProperties({
                CSB: csbLink,
                firstName: this.firstName,
                email: this.email,
                phone: this.phone,
                marketplaceGroupSku: this.marketplaceGroupSku,
                marketplaceGroup: this.marketplaceGroup,
                partnerName: this.partnerName,
                storeName: this.storeName,
                storeAlias: this.storeAlias,
                storeDomain: this.storeDomain
            });
        } else {
            this.hm.error('could not set tags and user properties in freshdesk chat because window.fcWidget is undefined');
        }
    }
});

module.exports = freshChat;
